import * as angular from 'angular';

import { ComponentDefinition, TimeInterval, IFrequency, IFrequencyValidationRule } from '../../models/index';

class PeriodSelectionController implements angular.IComponentController {
    allowAny: boolean;
    frequencyValidationRules: IFrequencyValidationRule[];
    isLoading: boolean;
    isRequired: boolean;
    label: string;
    loadingMessage: string;
    period: TimeInterval;
    
    static $inject = ['intervalValidationService'];

    constructor(private _intervalValidationService) {

    }

    $onInit() {
        this.frequencyValidationRules = [
            {
                key: 'interval',
                isValid: freq => {
                    return this.allowAny ? true : this._intervalValidationService.isValid(freq);
                }
            }
        ];
    }
}

export const wtPeriodSelection: ComponentDefinition = {
    componentId: 'wtPeriodSelection',
    controller: PeriodSelectionController,
    template: require('./periodSelection.component.html'),
    controllerAs: 'vm',
    bindings: {
        label: '@',
        period: '=',
        formController: '<?',
        field: '@?',
        allowAny: '<?',
        isDisabled: '<?',
        isRequired: '<?',
        min: '<?'
    }
};
